import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { setTokenManually } from './helpers/localToken';

const isLocal =
  process.env.NODE_ENV === 'development' || process.env.ENVIRONMENT === 'local';
if (isLocal) {
  setTokenManually();
}

ReactDOM.render(<App />, document.getElementById('root'));
